import { ScheduleInvoicesInput } from '@allocab/allocab-driver-shared-types';
import { useMutation } from '@tanstack/react-query';

import { driverApi } from '../services/network/Api';

const scheduleManyInvoices = (input: ScheduleInvoicesInput) =>
  driverApi.post<ScheduleInvoicesInput, void>('/v1/invoice/schedule-many', input);

export const useScheduleManyInvoices = () =>
  useMutation<void, unknown, ScheduleInvoicesInput>({
    mutationFn: scheduleManyInvoices,
  });
